import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './dashboard.css'; // Ensure this file exists

const Dashboard = () => {
  const navigate = useNavigate();
  const userName = "oluwatomiwa"; // Replace with dynamic user data when available

  // Account balance animation (updates every 10s)
  const [accountBalance, setAccountBalance] = useState(150.75);
  const [bonusBalance, setBonusBalance] = useState(20.50);

  useEffect(() => {
    const interval = setInterval(() => {
      // Simulate balance update
      setAccountBalance((prev) => prev + Math.random() * 1);
      setBonusBalance((prev) => prev + Math.random() * 5);
    }, 10000); // Updates every 10 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <h2>Dashboard</h2>
        <ul>
          <li onClick={() => navigate('/tasks')}>📋 Tasks</li>
          <li onClick={() => navigate('/wallet')}>💰 Wallet</li>
          <li onClick={() => navigate('/withdraw')}>💳 Withdraw</li>
          <li onClick={() => navigate('/referrals')}>👥 Referrals</li>
          <li onClick={() => navigate('/profile')}>👤 Profile</li>
          <li onClick={() => navigate('/')}>🚪 Logout</li>
        </ul>
      </aside>

      {/* Main Dashboard Content */}
      <main className="dashboard-content">
        <h1>Welcome, <span className="username">{userName}</span> 👋</h1>

        {/* Account Balance Card */}
        <div className="balance-card">
          <div className="balance-box">
            <h3>💰 Account Balance</h3>
            <p className="balance-amount">${accountBalance.toFixed(2)}</p>
          </div>
          <div className="balance-box bonus">
            <h3>🎉 Bonus Balance</h3>
            <p className="balance-amount">${bonusBalance.toFixed(2)}</p>
          </div>
        </div>

        {/* Other Dashboard Widgets */}
        <div className="dashboard-widgets">
          <div className="widget tasks-widget">
            <h3>🔥 Active Tasks</h3>
            <p>Complete tasks and earn rewards!</p>
          </div>
          <div className="widget earnings-widget">
            <h3>💸 Earnings</h3>
            <p>Track your earnings over time.</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
